import { getSupabase } from '../../supabaseClient';
import { NOTIFICATION_TYPES } from '../../utils/notifications';

/**
 * Follow or unfollow, safe to replay: it runs from the offline queue when a scan with no signal comes back online
 * (Sam, 2026-10-29: "it should, even like once they get back on service"). A follow that already exists is a success
 * and sends no second "New follower".
 */
export async function followWriteMutationFn({ action, viewerId, targetId, viewerName }) {
  const supabase = getSupabase();
  if (action === 'unfollow') {
    const { error } = await supabase
      .from('follows')
      .delete()
      .eq('follower_id', viewerId)
      .eq('following_id', targetId);
    if (error) throw error;
    return { action, targetId };
  }
  const { error } = await supabase
    .from('follows')
    .insert({ follower_id: viewerId, following_id: targetId });
  if (error && error.code === '23505') return { action, targetId, already: true };
  if (error) throw error;
  await supabase.from('notifications').insert({
    user_id: targetId,
    type: NOTIFICATION_TYPES.FOLLOW,
    title: 'New follower',
    message: `${viewerName || 'Someone'} started following you`,
    related_user_id: viewerId,
    read: false,
    created_at: new Date().toISOString(),
  });
  return { action, targetId };
}
